import PropTypes from 'prop-types';
import React from 'react';

import useArticle from '../../hooks/use_article';
import useGroup from '../../hooks/use_group';
import ArticlesListItem from './articles-list-item';

const ArticlesList = ({
	children,
	cols,
	exclude_articles,
	include_groups,
	include_markers,
	include_types,
	limit,
	page,
}) => {
	let empty = true;

	const { count: article_count, items: articles } = useArticle({
		exclude_articles,
		include_groups,
		include_markers,
		include_types,
		limit,
	});
	const { items: groups_data } = useGroup({ include_groups });

	const component = (
		<div className="row">
			{articles.map((article, index) => {
				let group = null;

				if (article.groups && article.groups.length) {
					group = groups_data.find(
						(value) => value.group_id == article.groups[0],
					);
				}

				const image_header = article?.fields?.files_header_url_src;
				if (empty) empty = false;
				return (
					<div className={`col-md-${cols}`} key={index}>
						<ArticlesListItem
							article_id={article.article_id}
							excerpt={article.article_variant.excerpt}
							group={{
								groups: article.groups,
								title: group?.group_variant?.title,
							}}
							image_header={image_header}
							page={page}
							published_at={article.published_at.substring(0, 10)}
							slug={article.article_variant.slug}
							title={article.article_variant.title}
						/>
					</div>
				);
			})}
		</div>
	);

	return children ? (
		<>{children(empty ? null : component, { article_count })}</>
	) : (
		component
	);
};

ArticlesList.propTypes = {
	children: PropTypes.any,
	cols: PropTypes.number,
	exclude_articles: PropTypes.array,
	include_groups: PropTypes.array,
	include_markers: PropTypes.array,
	include_types: PropTypes.array,
	limit: PropTypes.number,
	page: PropTypes.string,
};

export default ArticlesList;
